import React from 'react'
import { Row, Column, Box } from 'components/Layout'
import { Button } from 'components/Button'
import { Fade, SlideIn } from 'components/Transitions'
import { Modal, Background } from 'components/Overlay'
import { FormSection } from 'components/Form'

class ConfirmSubmissionCancelModal extends React.Component {
	constructor() {
		super()
		this.state = {
			loading: false
		}
	}
	render() {
		const { closePortal, submission, handleCancel } = this.props

		return (
			<Fade>
				<Background onClick={closePortal}>
					<SlideIn from="bottom">
						<Modal
							onClick={e => {
								e.stopPropagation()
							}}
						>
							<Row>
								<Column width={6}>
									<Box
										header={'Cancel the submission'}
										info={
											<Button
												onClick={e => {
													e.stopPropagation()
													closePortal()
												}}
												icon="close"
												type="ghost"
											/>
										}
										body={
											<div>
												<FormSection>
													<p>
														Are you sure you want to
														cancel the submission?
													</p>
												</FormSection>
												<FormSection right>
													<Button
														onClick={e => {
															e.stopPropagation()
															closePortal()
														}}
														icon="close"
														type="ghost"
													>
														Back to safety
													</Button>

													<span
														style={{
															marginLeft: '10px'
														}}
													/>
													<Button
														icon="delete_forever"
														htmlType="submit"
														loading={
															this.state.loading
														}
														onClick={e => {
															e.stopPropagation()
															this.setState({
																loading: true
															})
															handleCancel(
																submission
															)
														}}
													>
														{
															'Cancel the submission'
														}
													</Button>
												</FormSection>
											</div>
										}
									/>
								</Column>
							</Row>
						</Modal>
					</SlideIn>
				</Background>
			</Fade>
		)
	}
}

ConfirmSubmissionCancelModal.propTypes = {
	closePortal: React.PropTypes.func
}

export default ConfirmSubmissionCancelModal



// WEBPACK FOOTER //
// ./src/views/Modals/ConfirmSubmissionCancelModal.js